import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { DOWNLOAD_SOFTWARE } from '../constant/actionTypes';

const downloadSoftwareChartDataApiEndPoint = constants.ADMIN_URL;

const getDownloadSoftwareChartData = () => (dispatch) => httpservice()
  .get(`${downloadSoftwareChartDataApiEndPoint}${constants.API.DOWNLOAD_SOFTWARE_CHART}`)
  .then((downloadSoftwareChartData) => {
    dispatch({
      payload: downloadSoftwareChartData.data,
      type: DOWNLOAD_SOFTWARE.GET.SUCCESS,
    });
  })
  .catch((downloadSoftwareChartError) => {
    dispatch({
      payload: downloadSoftwareChartError,
      type: DOWNLOAD_SOFTWARE.GET.ERROR,
    });
  });

export default getDownloadSoftwareChartData;
